import React from 'react';
import PropTypes from 'prop-types';
import Ordinal from 'modules/Common/components/Ordinal';
import { Link } from 'react-router';
import Silk from 'modules/Common/components/Silk';
import { bracket} from 'modules/HorseRacing/utils';

HorseRacingFastRacecardRide.propTypes = {
  ride: PropTypes.object,
  favToken: PropTypes.string
}

export default function HorseRacingFastRacecardRide({
  ride,
  favToken
}) {

  const {
    horse_reference: {
      id: horseId
    } = {},
    position,
    amended_position: actualPosition = position,
    silk_filename: silkFilename,
    saddlecloth_number: clothNumber,
    draw_number: drawNumber,
    horse_name: horseName,
    odds: horseOdds,
    favourite
  } = ride;

  return (
    <div key={horseId} className="fast-results-place">
      <div className="fast-results-place-position">
        <Ordinal n={actualPosition} superscriptSuffix={false}/>
      </div>
      <div className="fast-results-place-silk">
        <Silk filename={silkFilename}/>
      </div>
      <div className="fast-results-stall-info">
        <div className="row">
          <span className="fast-results-saddle-cloth-no">{clothNumber}</span>
          {drawNumber && <span className="fast-results-runner-stall-no">{bracket(drawNumber)}</span>}
        </div>

      </div>                      
      <div className="fast-results-place-name">
        <Link to={`/racing/profiles/horse/${horseId}`}>{horseName}</Link>
      </div>
      <div className="fast-results-place-odds">
        {horseOdds} {favourite && favToken}
      </div>
    </div>
  );

}



// WEBPACK FOOTER //
// ./modules/HorseRacing/components/HorseRacingFastRacecardRide.js